import { CMSCourse, Course } from '../course/course.enum';
export enum CurriculumId {
  EurekaMath = 'EM',
  WitandWisdom = 'WW',
  PhDScience = 'PHD',
  Geodes = 'GEO',
  Invalid = 'Invalid',
}
export enum CurriculumAcma {
  EurekaMath = 'Eureka Math',
  WitAndWisdom = 'Wit and Wisdom',
  PhDScience = 'PhD Science',
  Geodes = 'Geodes',
}
export interface ICurriculum {
  id: string;
  label: string;
  title: string;
}
export interface FetchCurriculum {
  courses: CMSCourse[];
  id: string;
  studentsDisplayedTitle: string;
  Description: string;
  Type: string;
  InternalID: string;
  Product: string;
}
export interface Curriculum {
  courses: Course[];
  description: string;
  id: string;
  title: string;
  type: string;
  typeName: string;
  internalId: string;
  product: string;
}
interface CurriculumEnum {
  [key: string]: ICurriculum;
}
const CurriculumList: CurriculumEnum = {
  EM: {
    id: 'EM',
    label: CurriculumAcma.EurekaMath,
    title: 'Math'
  },
  GEO: {
    id: 'GEO',
    label: CurriculumAcma.Geodes,
    title: 'Geodes'
  },
  WW: {
    id: 'WW',
    label: CurriculumAcma.WitAndWisdom,
    title: 'English'
  },
  PHD: {
    id: 'PHD',
    label: CurriculumAcma.PhDScience,
    title: 'Science'
  },
  EMTX: {
    id: 'EMTX',
    label: CurriculumAcma.EurekaMath,
    title: 'Math - TEKS'
  },
  PHDTX: {
    id: 'PHDTX',
    label: CurriculumAcma.PhDScience,
    title: 'Science - TEKS'
  },
  PHDPILOT: {
    id: 'PHDPILOT',
    label: CurriculumAcma.PhDScience,
    title: 'Science K-2'
  }
};
export function getCurriculums(): ICurriculum[] {
  return [CurriculumList.EM, CurriculumList.WW, CurriculumList.PHD, CurriculumList.EMTX, CurriculumList.PHDTX, CurriculumList.PHDPILOT, CurriculumList.GEO];
}
export function getCurriculumFrom(value: string): ICurriculum | undefined {
  return getCurriculums().find(curriculum => curriculum.id === value);
}
export function getCurriculumByType(type: string): ICurriculum | undefined {
  return getCurriculums().find(curriculum => curriculum.label === type);
}
export function getCurriculumByInternalID(id: string): ICurriculum | undefined {
  const idToMatch = id.toUpperCase();
  return getCurriculums().find(curriculum => curriculum.id === idToMatch);
}